// Languages supported by Deepgram nova-3 (Indian languages beyond Hindi
// require nova-3; 'multi' = English/Hindi code-switching).
// Shared by the Call Analysis upload modal and the Recordings bulk-select bar.
export const LANGUAGE_OPTIONS = [
  { value: 'multi', label: 'Auto — code-switching (English + Hindi)' },
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'हिन्दी — Hindi' },
  { value: 'bn', label: 'বাংলা — Bengali' },
  { value: 'ta', label: 'தமிழ் — Tamil' },
  { value: 'te', label: 'తెలుగు — Telugu' },
  { value: 'mr', label: 'मराठी — Marathi' },
  { value: 'gu', label: 'ગુજરાતી — Gujarati' },
  { value: 'kn', label: 'ಕನ್ನಡ — Kannada' },
  { value: 'pa', label: 'ਪੰਜਾਬੀ — Punjabi' },
  { value: 'as', label: 'অসমীয়া — Assamese' },
  { value: 'ne', label: 'नेपाली — Nepali' },
  { value: 'ur', label: 'اردو — Urdu' },
];

// LLM provider choices for the analysis step.
//
// CLAUDE (Anthropic) is the default analysis AI and OLLAMA the alternative —
// chosen platform-wide in SuperAdmin → Settings → AI Call Analysis. Claude is
// listed once its API key is set; OpenAI only when the server .env sets
// CALL_ANALYSIS_LLM_FALLBACKS=true.
//
// availability: { openai, anthropic, ollama } from the /providers endpoint.
// ollamaInfo: { running, models } from the /providers endpoint — annotates the
// Ollama option with live daemon/model status.
export const buildProviderOptions = (availability = {}, ollamaInfo = {}) => {
  let ollamaHint = '';
  if (ollamaInfo.running === false) {
    ollamaHint = ' — not running';
  } else if (ollamaInfo.running === true && (ollamaInfo.models || []).length === 0) {
    ollamaHint = ' — no models installed';
  }

  const options = [];

  if (availability.anthropic === true) {
    options.push({ value: 'anthropic', label: 'Claude (Anthropic)' });
  }

  options.push({ value: 'ollama', label: `Ollama${ollamaHint}` });

  // Only reported as available with CALL_ANALYSIS_LLM_FALLBACKS=true
  if (availability.openai === true) {
    options.push({ value: 'openai', label: 'OpenAI' });
  }

  return options;
};